import script from "./ViewAttachmentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAttachmentModal.vue?vue&type=script&setup=true&lang=js"

import "./ViewAttachmentModal.vue?vue&type=style&index=0&id=4615bcfe&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4615bcfe"]])

export default __exports__